import Siema from './siema';


export default function (options) {
    window.carousel = window.carousel || {};


    if (typeof options === 'string') {
        options = {
            selector: options
        }
    }

    let carousel = document.querySelector(options.selector)

    if (!carousel) return;

    let prev = carousel.previousElementSibling
    let next = carousel.nextElementSibling



    if (typeof options.perPage === 'undefined') {
        options.perPage = {
            0: 2,
            768: 3,
            1024: 3,
            1180: 4,
            1300: 6
        }
    }

    function autoplay(carousel) {
        carousel.timer = setInterval(() => carousel.next(), 15000);
    }

    window.carousel[options.selector] = new Siema(options)

    autoplay(window.carousel[options.selector]);

    prev.addEventListener('click', () => window.carousel[options.selector].prev());
    next.addEventListener('click', () => window.carousel[options.selector].next());
}
